import React, { useEffect, useState } from "react";
import { Card, Typography, Tag, Tabs, Table, Image, Spin } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import moment from "moment";
import { getSingleSurveyor } from "../../../api/CommonRequest";
import BidList from "./BidList";
import SurveyList from "./SurveyList";
const { Text } = Typography;
const { TabPane } = Tabs;

const SurveyorSingleView = ({ id }) => {
  const [surveyorData, setSurveyorData] = useState("");

  const [loader, setLoader] = useState(false);
  const [mySurveys, setMySurveys] = useState([]);
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const [filterStatus, setFilterStatus] = useState("All");
  const [totalSurveyDone, setTotalSurveyDone] = useState(0);
  const [totalBidDone, setTotalBidDone] = useState(0);

  const [bankDetails, setBankDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true)
        const { data } = await getSingleSurveyor(id);
        console.log(data, "data");

        if (data.success) {
          setSurveyorData(data.singleSurveyor);
          setBankDetails(data.bankDetails);
          setTotalSurveyDone(data.totalSurvey ? data.totalSurvey : 0);

          setTotalBidDone(data.totalBid ? data.totalBid : 0);
          setMySurveys(data.surveyorSurvey);
          setFilteredSurveys(data.surveyorSurvey);
          setLoader(false)

        }
      } catch (error) {
        setLoader(false)

        console.log(error);
      }
    };

    fetchData();
  }, [id]);

  // useEffect(() => {
  //   if (filterStatus === "All") {
  //     setFilteredSurveys(mySurveys);
  //   } else {
  //     const filtered = mySurveys.filter(
  //       (survey) => survey.status === filterStatus
  //     );
  //     setFilteredSurveys(filtered);
  //   }
  // }, [filterStatus, mySurveys]);

  const handleFilterChange = (value) => {
    console.log(value, "value");

    setFilterStatus(value);
  };



  const columns = [
    {
      title: "",
      dataIndex: "checkbox",
      key: "checkbox",
      render: () => <input type="checkbox" />,
      width: 50,
    },
    {
      title: "Survey Name",
      dataIndex: "surveyName",
      key: "surveyName",
    },
    {
      title: "Client Details",
      key: "clientDetails",
      render: (_, record) => (
        <>
          <div>
            <span>
              {record.state} , {record.district} , {record.city}
            </span>
          </div>
          <span>{record.address}</span>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Ongoing" ? "green" : "blue"}>{status}</Tag>
      ),
    },
    {
      title: "Bids Added",
      dataIndex: "bidsAdded",
      key: "bidsAdded",
    },
    {
      title: "Completion Date",
      dataIndex: "completionDate",
      key: "completionDate",
    },
    {
      title: "Assigned Date",
      dataIndex: "assignedDate",
      key: "assignedDate",
      render: (assignedDate) => moment(assignedDate).format("DD/MM/YYYY"),
    },
  ];

  return (
    <Spin spinning={loader}>
      <div className="flex-grow  scrollbar-hide p-4 lg:p-6 md:p-5">
        <div
          style={{
            padding: "24px",
            // backgroundColor: "#f0f2f5",
            minHeight: "100vh",
          }}
        >
          <Card className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 ">
              <div className="flex gap-6">
                <Image
                  width={155}
                  height={155}
                  src={surveyorData?.profileImage}
                  fallback="/path-to-default-image.png"
                  className="object-cover rounded-lg"
                  style={{
                    border: "2px solid #fff",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                />
                <div>
                  <Text
                    strong
                    className="text-lg mb-1 block text-center md:text-left"
                  >
                    {surveyorData?.name}
                  </Text>
                  <div className="flex flex-col items-center md:items-start">
                    <div className="flex items-center mb-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      <Text>Available Now</Text>
                    </div>

                    <Text className="mb-1 flex items-center">
                      <MailOutlined className="mr-2" />
                      <span className="text-blue-500 underline">
                        {surveyorData?.email}
                      </span>
                    </Text>

                    <Text className="mb-1 flex items-center">
                      <PhoneOutlined className="mr-2" />
                      <span className="text-blue-500 underline">
                        {surveyorData?.phone}
                      </span>
                    </Text>
                    <div className="flex justify-between items-center gap-4">
                      <span className="text-sm text-gray-600">Joined Date</span>
                      <span className="font-semibold">
                        {moment(surveyorData?.createdAt).format("DD MMM YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="flex justify-left  text-[#313131] font-semibold border-b border-[#1955EB]">
                  Address Info
                </div>

                <div className="flex flex-col items-start text-left mt-4">
                  <Text>{surveyorData?.roleDetails?.address}</Text>
                </div>
              </div>

              <div>
                <div className="flex justify-left  text-[#313131] font-semibold border-b border-[#1955EB]">
                  Survey Info
                </div>

                <div className="flex flex-col space-y-2 mt-4">
                  {/* <div className="flex justify-between items-center">
                  <Text className="text-gray-600">Survey Category:</Text>
                  <Text strong>
                    {surveyorData?.category
                      ? surveyorData.category.join(", ")
                      : "N/A"}
                  </Text>
                </div> */}
                  <div className="flex flex-col ">
                    <div className="flex justify-between">
                      <Text className="text-gray-600">State:</Text>
                      <Text strong>
                        {surveyorData?.roleDetails?.state
                          ? surveyorData.roleDetails.state.join(", ")
                          : "N/A"}
                      </Text>
                    </div>
                    <div className="flex justify-between">
                      <Text className="text-gray-600">District:</Text>
                      <Text strong>
                        {surveyorData?.roleDetails?.district
                          ? surveyorData.roleDetails.district.join(", ")
                          : "N/A"}
                      </Text>
                    </div>
                    <div className="flex justify-between">
                      <Text className="text-gray-600">City:</Text>
                      <Text strong>
                        {surveyorData?.roleDetails?.city
                          ? surveyorData.roleDetails.city.join(", ")
                          : "N/A"}
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="flex gap-10 mt-4">
            <div className="w-1/3">
              <Card className="h-full">
                <div className="space-y-4">
                  <div className="flex justify-left  text-[#313131] text-[20px] font-semibold border-b border-[#1955EB]">
                    About
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Total Surveys Completed
                    </span>
                    <span className="font-semibold">{totalSurveyDone}</span>
                  </div>


                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Total Bid Completed</span>
                    <span className="font-semibold">{totalBidDone}</span>
                  </div>

                </div>
              </Card>
            </div>
            <div className="w-1/3">
              <Card className="h-full">
                <div>
                  <div className="flex justify-left text-[#313131] font-semibold border-b border-[#1955EB]">
                    Bank Details
                  </div>
                  <div className="flex flex-col space-y-2 mt-4">
                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">Account Name:</Text>
                      <Text strong>
                        {bankDetails?.accountHolderName || "N/A"}
                      </Text>
                    </div>
                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">Account No:</Text>
                      <Text strong>{bankDetails?.accountNumber || "N/A"}</Text>
                    </div>
                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">Bank Name:</Text>
                      <Text strong>{bankDetails?.bankName || "N/A"}</Text>
                    </div>

                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">Branch:</Text>
                      <Text strong>{bankDetails?.branchName || "N/A"}</Text>
                    </div>
                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">IFSC Code:</Text>
                      <Text strong>{bankDetails?.ifscCode || "N/A"}</Text>
                    </div>
                    <div className="flex justify-between items-center">
                      <Text className="text-gray-600">Razorpay:</Text>
                      <Text strong>{bankDetails?.fundAccountId ? "Connected" : "Not Connected"}</Text>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>

          <Card style={{ marginTop: "24px" }}>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Surveys Assigned" key="1">
                <SurveyList id={id} />

              </TabPane>
              <TabPane tab="Bid List" key="2">
                <BidList id={id} />
              </TabPane>
            </Tabs>
          </Card>
        </div>
      </div>
    </Spin>
  );
};

export default SurveyorSingleView;
